import { render, staticRenderFns } from "./AgItem.vue?vue&type=template&id=0971b3f0&"
import script from "./AgItem.vue?vue&type=script&lang=js&"
export * from "./AgItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports